/**
 * This is a map to establish a workaround for incoming links that are not properly categorized.
 * Incoming redirects from the old API Portal are not categorized, so we need to map them to the correct category.
 * Example: /default/documentation/:specName
 */
export const specCategoryMap: { [key: string]: string } = {
  // account-management
  'bizapi-prod_lookup': 'account-management/specs/gateway-mac-address-lookup',
  'bizapi-prod_lookup-onboarding-status':
    'account-management/specs/gateway-onboarding-status',

  // core-wifi
  'coverage-prod_config-sets': 'core-wifi/specs/config-sets-api',
  'coverage-prod_connectivity-state':
    'core-wifi/specs/connectivity-state-service',
  'coverage-prod_device-usage-stats':
    'core-wifi/specs/device-connection-usage-stats',
  'coverage-prod_gateway-reachability':
    'core-wifi/specs/verify-gateway-reachability',
  'coverage-prod_gateway-restart': 'core-wifi/specs/gateway-restart-api',
  'coverage-prod_ip-gateway-device-connections':
    'core-wifi/specs/ip-gateway-device-connections-api',
  'coverage-prod_wifi-extenders': 'core-wifi/specs/wifi-extenders',

  // digital-security
  'person-prod_advancedsecurity':
    'digital-security/specs/pom-advanced-security-service',

  // family-settings
  'person-prod_kontrol': 'family-settings/specs/controls-api',
  'person-prod_places': 'family-settings/specs/place-api',
  'person-prod_profile': 'family-settings/specs/profile-api',

  // internet-performance
  'high-speed-optimization-prod_device-prioritization-api-spec':
    'internet-performance/specs/device-prioritization-api',
  'speed-test-prod_blaster': 'internet-performance/specs/hso-wifi-blaster',
  'speed-test-prod_gateway-speed-test':
    'internet-performance/specs/gateway-speed-test-api',
  'wisp-prod_dis-api-spec':
    'internet-performance/specs/wisp-device-identification-service-dis-api',
  'wisp-prod_wifi-test-api-spec':
    'internet-performance/specs/wisp-wifi-test-api',

  // operations-insights-and-reports
  'device-connection-usage-stats':
    'operations-insights-and-reports/specs/device-connection-usage-stats',
  'ip-gateway-device-connections-api':
    'operations-insights-and-reports/specs/ip-gateway-device-connections-api',
};
